import {RazorpayOptions} from "./@types/RazorpayOptions";

/**
 * Utility class for handling Razorpay payments.
 */
export class RazorpayClient {
  private static scriptLoaded = false;

  /**
   * Loads the Razorpay checkout script dynamically.
   * @returns A promise that resolves when the script is successfully loaded.
   */
  static async loadScript(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) return resolve(true);

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => {
        this.scriptLoaded = true;
        resolve(true);
      };
      script.onerror = () =>
        reject(new Error("Error while loading razorpay script"));
      document.body.appendChild(script);
    });
  }

  /**
   * Opens the Razorpay checkout modal with the provided options.
   * @param {RazorpayOptions} options - Configuration options for the Razorpay payment.
   */
  static async openPayment(options: RazorpayOptions): Promise<void> {
    const isLoaded = await this.loadScript();
    if (!isLoaded) throw new Error("Failed to load Razorpay SDK");

    const razorpay = new (window as any).Razorpay(options);
    razorpay.open();
  }
}
